// extracted by mini-css-extract-plugin
export var active = "_h6-7";
export var blink = "_h6-8";
export var dropDownSelector = "_h6-4";
export var dropDownWrapper = "_h6-3";
export var fakeCursor = "_h6-6";
export var fontSizeButton = "_h6-9";
export var formQuillEditor = "_h6-0";
export var pressed = "_h6-a";
export var qlBlank = "_h6-1";
export var textFormattingToolbar = "_h6-2";
export var textToolbarOption = "_h6-5";